import React from "react";
import "./GlobalLoader.scss";
import { CampusMeshLogo } from "../CampusLogo";
import { GlobalLoaderLogo } from "./GlobalLoaderLogo";


const GlobalLoader = () => {
  return (
    <div className="whatsapp-loader-wrapper">
      <GlobalLoaderLogo />
      <div className="whatsapp-loader">
        <div className="loader-bar"></div>
      </div>
    </div>
  );
};

export default GlobalLoader;
